import {
    SET_REPORTS_LIST,
    SET_REPORTS_LIST_FETCH_STATUS,
    SET_HISTORY,
    SET_HISTORY_PAGE,
    SET_HISTORY_FETCH_STATUS,
    SET_REPORTS_LIST_OPEN_VALUE,
    SET_REPORTS_LIST_FILTERS,
    SET_HISTORY_MANAGE_MODE_IS_ON,
    SET_HISTORY_MANAGE_MODE_SELECTED_ENTRIES,
} from './constants';
import {
    LOGOUT
} from '../LoginPage/constants';

const initialState = {
    reportsList: [],
    reportsListIsOpen: false,
    reportsListFilters: {
        reportType: null,
        fromDate: null,
        tilDate: null,
    },
    reportsListFetchStatus: {
        loading: false,
        error: false,
        retryCount: 0,
        lastTimeStamp: 0,
    },

    history: {},
    historyPage: 1,
    historyFetchStatus: {
        loading: false,
        error: false,
        retryCount: 0,
    },

    historyManageMode: {
        isOn: false,
        selectedEntries: [],
    },
}

const reports = (state = initialState, {
    type,
    payload,
}) => {
    switch (type) {
        case SET_REPORTS_LIST:
            return {
                ...state,
                reportsList: payload,
                reportsListFetchStatus: {
                    ...state.reportsListFetchStatus,
                    lastTimeStamp: Date.now(),
                },
            };

        case SET_REPORTS_LIST_OPEN_VALUE:
            return {
                ...state,
                reportsListIsOpen: typeof payload === 'boolean' ?
                    payload : !state.reportsListIsOpen,
            }

        case SET_REPORTS_LIST_FILTERS:
            return {
                ...state,
                reportsListFilters: {
                    ...state.reportsListFilters,
                    ...payload,
                },
            }

        case SET_REPORTS_LIST_FETCH_STATUS:
            return {
                ...state,
                reportsListFetchStatus: {
                    ...state.reportsListFetchStatus,
                    ...payload,
                },
            }

        case SET_HISTORY:
            return {
                ...state,
                history: payload,
            };

        case SET_HISTORY_PAGE:
            return {
                ...state,
                historyPage: payload,
            };

        case SET_HISTORY_FETCH_STATUS:
            return {
                ...state,
                historyFetchStatus: {
                    ...state.historyFetchStatus,
                    ...payload,
                },
            }

        case SET_HISTORY_MANAGE_MODE_IS_ON:
            return {
                ...state,
                historyManageMode: payload === false ? {
                    isOn: false,
                    selectedEntries: [],
                } : {
                    ...state.historyManageMode,
                    isOn: true,
                },
            }

        case SET_HISTORY_MANAGE_MODE_SELECTED_ENTRIES:
            return {
                ...state,
                historyManageMode: {
                    ...state.historyManageMode,
                    selectedEntries: payload,
                },
            }

        case LOGOUT:
            return initialState;

        default:
            return state;
    }
}

export default reports;



// WEBPACK FOOTER //
// ./app/web/src/container/ReportsPage/reducer.js